import { useDebugValue, useState } from 'react';
import { interceptErrorMessage } from '../../shared/helpers/apiErrorsInterceptor';

import ajaxClient from '../../utils/ajaxClient';
import { HEADER_VALUE__CONTENT_TYPE } from '../../utils/ajaxClient/constants';

const useChangePasswordHook = () => {
  useDebugValue('useChangePasswordHook');

  const [isSending, setIsSending] = useState(false);

  const changePassword = (newPassword, token, onSuccess, onError) => {
    setIsSending(true);
    const url = 'Users/Password/Change';
    const data = { newPassword, token };

    return ajaxClient
      .postRequest(url, null, data, HEADER_VALUE__CONTENT_TYPE)
      .then((response) => {
        if (response) {
          setIsSending(false);
          if (onSuccess) {
            onSuccess();
          }
        }
      })
      .catch((exception) => {
        if (exception) {
          if (onError) {
            onError(interceptErrorMessage(exception));
          }

          setIsSending(false);
        }
      });
  };

  return { changePassword, isSending };
};

export default useChangePasswordHook;
